import {createAction, props} from '@ngrx/store';
import {ApiLogObj2} from '../../../shared-utilities/models-old/datastructures';
import {IStockHistoryEvent, IStockHistoryItemOrigin, IStockHistorySelectedItemSnapshot} from '../models/stock-history-interfaces';

export const loadStockHistoryFirstPage = createAction(
  '[Stock History] Load First Page',
  props<{ storeId: string; itemCodes?: string[]; field?: string }>(),
);

export const loadStockHistoryNextPage = createAction(
  '[Stock History] Load Next Page',
);

export const loadStockHistorySuccess = createAction(
  '[Stock History] Load Success',
  props<{
    events: IStockHistoryEvent[];
    lastDocumentId: string | null;
    hasMore: boolean;
    isFirstPage: boolean;
  }>(),
);

export const loadStockHistoryFailure = createAction(
  '[Stock History] Load Failure',
);

export const stockHistorySetStoreContext = createAction(
  '[Stock History] Set Store Context',
  props<{ storeId: string }>(),
);

export const updateStockHistorySearchTerm = createAction(
  '[Stock History] Update Search Term',
  props<{ itemCodes: string[]; field?: string; selectedItems?: IStockHistorySelectedItemSnapshot[] }>(),
);

export const loadStockHistoryItemOriginsSuccess = createAction(
  '[Stock History] Load Item Origins Success',
  props<{ itemOrigins: IStockHistoryItemOrigin[] }>(),
);

export const resetStockHistoryState = createAction(
  '[Stock History] Reset State',
);

export const clearStockHistoryData = createAction(
  '[Stock History] Clear Stock History Data',
);

export const openStockHistoryModal = createAction(
  '[Stock History] Open Modal',
);

export const closeStockHistoryModal = createAction(
  '[Stock History] Close Modal',
);

export const openStockHistoryDetailView = createAction(
  '[Stock History] Open Detail View',
  props<{ event: ApiLogObj2 }>(),
);
